export enum EKYCReviewStatus {
  INITIAL_ACTION_REQUIRED = "Initial Action Required",
  AWAITING_EMPLOYER = "Awaiting Employer",
  AWAITING_WORKER = "Awaiting Worker",
  AWAITING_REVIEW = "Awaiting Review",
}
